import { render } from "./PrintPage.vue?vue&type=template&id=32714b63&scoped=true"
import script from "./PrintPage.vue?vue&type=script&lang=js"
export * from "./PrintPage.vue?vue&type=script&lang=js"

import "./PrintPage.vue?vue&type=style&index=0&id=32714b63&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32714b63"]])

export default __exports__